import { useEffect, useRef } from "react";

/**
 * `?open=first` query parametresini MOUNT'ta bir kez okur ve URL'den temizler.
 *
 * - Değeri ilk render'da senkron olarak yakalar (ref) → tüketici bileşene hemen `true` döner.
 * - URL'i `replaceState` ile temizler (tıpkı `#newitem` deseni gibi) → remount/tab geçişinde
 *   tekrar tetiklenmez; kullanıcı sonradan başka öğe gezerken ilk öğeye geri atlamaz.
 *
 * Opt-in: yalnızca bu parametre URL'de varsa `true` döner. Reusable (demo + ileride signup).
 */
export const useOpenFirstParam = () => {
  const valueRef = useRef(null);

  if (valueRef.current === null) {
    try {
      const params = new URLSearchParams(window.location.search);
      valueRef.current = params.get("open") === "first";
    } catch {
      valueRef.current = false;
    }
  }

  useEffect(() => {
    if (!valueRef.current) return;
    try {
      const url = new URL(window.location.href);
      url.searchParams.delete("open");
      window.history.replaceState(null, "", url.pathname + url.search + url.hash);
    } catch {
      /* yoksay */
    }
  }, []);

  return valueRef.current;
};
